<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.area_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.area_form.add_form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.area_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>
        <form>
          <div class="form-row d-flex align-items-end">
            <div class="form-group col-md-6">
              <label for="name">{{
                $t("lang.admin.area_form.label_stock")
              }}</label>
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="input.stock"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="email">{{
                $t("lang.admin.area_form.label_description")
              }}</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="input.description"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group select-box col-md-12">
              <label for="reader_type">{{
                $t("lang.admin.area_form.label_select_location")
              }}</label>
              <select
                class="form-control"
                id="reader_type"
                v-model="input.location_id"
              >
                <option
                  v-for="(location, index) in locations"
                  :key="index"
                  :value="location.id"
                  >{{ location.description }}</option
                >
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group mb-0 col-md-12">
              <v-btn text rounded type="reset" @click="$router.back()">{{
                $t("lang.location_form.btn_cancel")
              }}</v-btn>
              <bx-btn type="submit" color="primary" @click="submitForm">{{
                $t("lang.admin.area_form.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
let Input = () => {
  return {
    stock: null,
    description: null,
    location_id: null
  };
};

export default {
  name: "AddUserForm",
  data() {
    return {
      input: new Input(),
      errors: [],
      locations: [],
      success: {
        show: false,
        message: this.$t("lang.admin.area_form.success_add")
      },
      errorLabels: {
        stock: this.$t("lang.admin.area_form.errors.stock"),
        description: this.$t("lang.admin.area_form.errors.description"),
        location: this.$t("lang.admin.area_form.errors.location")
      }
    };
  },
  async mounted() {
    this.locations = await this.$api.location.list();
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.input);

      if (this.validate()) {
        input.stock = parseInt(input.stock);
        // console.log(input)

        try {
          let response = await this.$api.area.add(input);
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
          console.error(error);
        } finally {
          this.input = new Input();
          this.success.show = true;
        }
      }
    },
    validate() {
      this.errors = [];
      this.success.show = false;

      let error = false;

      if (!this.input.stock) {
        error = true;
        this.errors.push(this.errorLabels.stock);
      }

      if (!this.input.description) {
        error = true;
        this.errors.push(this.errorLabels.description);
      }

      if (!this.input.location_id) {
        error = true;
        this.errors.push(this.errorLabels.location);
      }

      if (error) {
        return false;
      }

      return true;
    }
  }
};
</script>
